import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import SquareCheckbox from './SquareCheckbox';
import styled from 'styled-components';

type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
  itemName?: string;
  duration?: number;
  staffName?: string;
  remove?: (name: number) => void;
  fieldName: number;
  staffAvatar?: string;
};

const ServiceSyncWatingV2Item = ({
  value,
  onChange,
  itemName,
  duration,
  staffName,
  remove,
  fieldName,
  staffAvatar,
}: Props) => {
  const onRemove = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    remove?.(fieldName);
  };

  const onSelect = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onChange?.(!value);
  };

  const label = `${fieldName + 1}. ${itemName}`;
  const timeLabel = ` (${duration}m)`;

  return (
    <Container onClick={onSelect} className={`${value ? 'active' : ''}`}>
      <SquareCheckbox
        value={!!value}
        label={
          <>
            <span>{label}</span>
            <span style={{ color: 'red' }}>{timeLabel}</span>
          </>
        }
      />

      <RightBox>
        <div className='avatar_box'>
          <Avatar src={staffAvatar} size={40} icon={<UserOutlined />} />
          <div className={`staff_name ${!staffName ? 'none_staff' : ''}`}>
            {staffName || 'Select staff'}
          </div>
        </div>
        <div onClick={onRemove} style={{ cursor: 'pointer', display: 'flex' }}>
          <CloseIcon />
        </div>
      </RightBox>
    </Container>
  );
};

export default ServiceSyncWatingV2Item;

const Container = styled.div`
  flex: 1;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #86909c;
  background: #fff;
  padding: 8px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  &.active {
    border-color: #d2464f;
    box-shadow: 4px 4px 16px 4px rgba(210, 70, 79, 0.15);
  }
`;

const RightBox = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  .avatar_box {
    display: flex;
    align-items: center;
    gap: 4px;
    .staff_name {
      color: #1d2129;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
      text-transform: uppercase;
    }
    .none_staff {
      color: #4384ff;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
      text-transform: capitalize;
    }
  }
`;

const CloseIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.6184 3.18102C17.995 3.5576 17.995 4.16817 17.6184 4.54476L5.34472 16.8184C4.96813 17.195 4.35756 17.195 3.98098 16.8184C3.60439 16.4418 3.60439 15.8313 3.98098 15.4547L16.2547 3.18102C16.6312 2.80443 17.2418 2.80443 17.6184 3.18102Z'
      fill='#DA072D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.98122 3.18102C4.3578 2.80443 4.96837 2.80443 5.34496 3.18102L17.6186 15.4547C17.9952 15.8313 17.9952 16.4418 17.6186 16.8184C17.242 17.195 16.6315 17.195 16.2549 16.8184L3.98122 4.54476C3.60463 4.16817 3.60463 3.5576 3.98122 3.18102Z'
      fill='#DA072D'
    />
  </svg>
);
